// extracted by mini-css-extract-plugin
export default {"main":"register_main__9oRNM","login":"register_login__q-Yc4"};